import Login from 'modules/auth/login';

export default Login;
